/* Coupon urgency countdown (DG-2443). Cosmetic only — never touches coupon state. */
(function () {
  'use strict';

  const URL_PARAM = 'fastrrCouponCodeFromLink';
  const STORAGE_KEY = 'zopCouponTimerDeadline';
  const TICK_MS = 1000;
  const URGENT_MS = 5000;

  let nodes = [];
  let durationMs = 0;
  let productId = null;
  let deadline = 0;
  let intervalId = null;
  let expired = false;

  function readUrlCoupon() {
    try {
      const raw = new URLSearchParams(window.location.search).get(URL_PARAM);
      return (raw || '').trim() || null;
    } catch (e) {
      return null;
    }
  }

  function readStored() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || typeof parsed.deadline !== 'number') return null;
      // A different product, or a merchant edit to the metafield, invalidates the
      // frozen deadline. An elapsed deadline does not — it is what makes a reload
      // after zero come back expired instead of restarting the countdown.
      if (String(parsed.productId) !== String(productId)) return null;
      if (Number(parsed.durationMs) !== durationMs) return null;
      return parsed.deadline;
    } catch (e) {
      return null;
    }
  }

  function persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ deadline: deadline, productId: productId, durationMs: durationMs }));
    } catch (e) {}
  }

  function formatClock(ms) {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return minutes + ':' + String(seconds).padStart(2, '0');
  }

  function paint(remaining) {
    const clock = formatClock(remaining);
    const ratio = durationMs > 0 ? Math.max(0, Math.min(1, remaining / durationMs)) : 0;
    nodes.forEach(function (node) {
      const clockEl = node.querySelector('[data-timer-clock]');
      const fillEl = node.querySelector('[data-timer-fill]');
      if (clockEl && clockEl.textContent !== clock) clockEl.textContent = clock;
      if (fillEl) fillEl.style.width = (ratio * 100).toFixed(2) + '%';
    });
  }

  function setUrgent(on) {
    nodes.forEach(function (node) { node.classList.toggle('is-urgent', on); });
  }

  function expire() {
    expired = true;
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    paint(0);
    setUrgent(false);
    nodes.forEach(function (node) { node.classList.add('is-expired'); });
  }

  function tick() {
    if (expired) return;
    const remaining = deadline - Date.now();
    if (remaining > 0) {
      paint(remaining);
      setUrgent(remaining <= URGENT_MS);
      return;
    }
    expire();
  }

  function start() {
    if (!readUrlCoupon()) return;

    nodes = Array.prototype.slice.call(document.querySelectorAll('[data-zop-coupon-timer]'));
    if (!nodes.length) return;

    const minutes = Number(nodes[0].getAttribute('data-duration-minutes'));
    if (!minutes || isNaN(minutes) || minutes <= 0) return;
    durationMs = minutes * 60 * 1000;

    const bootstrap = document.querySelector('script[data-zop-coupon-bootstrap]');
    productId = bootstrap ? bootstrap.getAttribute('data-product-id') : null;

    const stored = readStored();
    if (stored !== null) {
      deadline = stored;
    } else {
      deadline = Date.now() + durationMs;
      persist();
    }

    nodes.forEach(function (node) { node.hidden = false; });
    tick();
    if (!expired) intervalId = setInterval(tick, TICK_MS);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
